import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { Modal, ModalBody } from 'reactstrap';
import Swal from 'sweetalert2';
import ReactGA from 'react-ga'
import { useNavigate } from 'react-router-dom';
import { handleWhatsAppClick } from '../whatsappClickTrack';

function GetAQuote({ openModal, toggle, name, options, buttonName, appName, interval, from }) {
    const [userData, setUserData] = useState({ name: '', email: '', phone: '', message: '', category: '' });
    const [errors, setErrors] = useState({});
    const [showError, setShowError] = useState(false);
    const [defaultCountry, setDefaultCountry] = useState('us');
    const [phoneNumber, setPhoneNumber] = useState({ dialingCode: '', number: '' });
    const countryFetched = useRef(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData((prev) => ({
            ...prev, [name]: value
        }))
    }
    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        const isFormValid = validateForm();
        let subject;
        if (appName)
            subject = { From: `${appName} button on product landing page` }
        if (from)
            subject = { From: `${from} button on product landing page` }
        else
            subject = { From: 'Get A Free Quote button' }
        if (isFormValid) {
            ReactGA.event({
                category: 'Get a quote Form',
                action: `Submit get a quote form `
            })
            const body = new FormData();
            body.append('name', userData.name);
            body.append('email', userData.email);
            body.append('subject', JSON.stringify(subject));
            body.append('phone', `${phoneNumber.dialingCode} ${phoneNumber.number}`);
            body.append('message', userData.message);
            let url = 'https://noorisys.com/contact-submit/landing-form.php';
            // let url = 'https://nakbho.techtrial.life/patient/auth/send-email';
           

            const body1 = new FormData();
            body1.append('name', userData.name);
            body1.append('email', userData.email);           
                body1.append('inquiry_source', '20');
            
            if(appName == undefined) {
                body1.append('inquiry_for', 'landing page');
            } else {
                body1.append('inquiry_for', appName);
            }
            body1.append('mobile', `+${phoneNumber.dialingCode}${phoneNumber.number}`);
            body1.append('message', userData.message);
            let url2 = 'https://crm.thetechtrial.com/backend/api/inquiry/add';
            axios
                .post(url2, body1)
                .then((result) => {
                    // event.target.reset();
                    setUserData({ name: '', email: '', phone: '', message: '' });
                    toggle();
                    // Swal.fire({ title: 'Thank you', icon: 'success', text: 'Thank you for reaching out to us! Your inquiry has been received. Our team will review your request and get back to you shortly.' })
                    navigate('/thankyou')
                },
                    (error) => {
                        Swal.fire({ title: 'Oops', icon: 'error', text: 'Something wrong happened please try again later' })
                    }
                );

            axios
                .post(url, body)
                .then((result) => {
                    // event.target.reset();
                    setUserData({ name: '', email: '', phone: '', message: '' });
                    toggle();
                    // Swal.fire({ title: 'Thank you', icon: 'success', text: 'Thank you for reaching out to us! Your inquiry has been received. Our team will review your request and get back to you shortly.' })
                    navigate('/thankyou')
                },
                    (error) => {
                        Swal.fire({ title: 'Oops', icon: 'error', text: 'Something wrong happened please try again later' })
                    }
                );
        }
        else {
            setShowError(true);
            ReactGA.event({
                category: 'Get a quote Form',
                action: `Submit get a quote form with failed validation `
            })
        }
    }
    const validateForm = () => {
        const newErrors = {};
        const phoneNumberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        if (userData.name.trim() === "") {
            newErrors.name = "Please provide your name";
        }

        // Validate Email
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
            newErrors.email = "Please Provide valid email address ";
        }

        if (userData.email.trim() === "") {
            newErrors.email = "Please provide email address";
        }

        if (!phoneNumberRegex.test(phoneNumber.number)) {
            newErrors.phone = "Please provide valid phone number";
        }

        if (phoneNumber.number === "") {
            newErrors.phone = "Please provide phone number";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }
    useEffect(() => {
        if (!countryFetched.current) {
            axios.get('https://ipapi.co/json/')
                .then(response => {
                    const countryCode = response.data.country_code.toLowerCase();
                    setDefaultCountry(countryCode);
                    countryFetched.current = true;
                })
                .catch(error => {
                    console.error("Error fetching user location: ", error);
                });
        }
    }, []);
    return (
        <div>
            <Modal isOpen={openModal} toggle={toggle} size='lg' centered className="custom-modal">
                {/* <ModalHeader toggle={toggle} className='d-flex justify-content-center'>{name}</ModalHeader> */}
                <ModalBody className='form-block'>
                    <button type="button" className="custom-close-button" aria-label="Close" onClick={toggle}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className='form-body'>
                        <form className=''>
                            <h4 className='text-center my-4' style={{ fontWeight: '400' }} >Please fill out the required details so we can get back to you promptly.</h4>
                            <div className='row'>
                                <div className='col-lg-6 col-12 fieldsets'>
                                    <label htmlFor='technology-name' className='form-label'>Name</label>
                                    <input placeholder="Enter Your Full Name" className='input-ree' value={userData.name} type='text' name="name" id='technology-name' onChange={handleChange} />
                                    {showError && errors.name && < span style={{ color: 'red', fontSize: '14px' }}>{errors.name}</span>}
                                </div>
                                <div className='col-lg-6 col-12 fieldsets'>
                                    <label htmlFor='technology-email' className='form-label'> Email Address</label>
                                    <input placeholder='Enter your Email Address' className='input-ree' value={userData.email} type='email' name="email" id='technology-email' onChange={handleChange} />
                                    {showError && errors.email && <span style={{ color: 'red', fontSize: '14px' }}>{errors.email}</span>}
                                </div>
                                <div className='col-lg-6 col-12 fieldsets'>
                                    <label htmlFor='technology-email' className='form-label'>Mobile Number</label>
                                    {/* <input placeholder='Mobile Number' className='input-ree' value={userData.email} type='email' name="email" id='technology-email' onChange={handleChange} /> */}
                                    <div style={{ marginBottom: '14px' }}>
                                        <PhoneInput
                                            country={defaultCountry}
                                            // value={this.state.phone}
                                            onChange={(value, data) => {
                                                const dialingCode = data?.dialCode;
                                                const phoneNo = value.substring(data.dialCode?.length);
                                                setPhoneNumber({ number: phoneNo, dialingCode: dialingCode })
                                            }}
                                            inputClass='phone-input'
                                            buttonStyle={{ borderRadius: '6px 0 0 6px' }}
                                            placeholder='Enter Your Mobile Number'
                                        // containerClass='input-ree'

                                        />
                                    </div>
                                    {showError && errors.phone && <span style={{ color: 'red', marginTop: '10px', paddingBottom: '10px', fontSize: '14px' }}>{errors.phone}</span>}
                                </div>

                                <div className='col-lg-6 col-12 fieldsets'>
                                    <label htmlFor='technology-message' className='form-label'> Comment</label>
                                    <input placeholder='Your Comments or Project Requirements' className='input-ree' value={userData.message} type='email' name="message" id='technology-email' onChange={handleChange} />
                                    {showError && errors.message && <span style={{ color: 'red', fontSize: '14px' }}>{errors.email}</span>}
                                </div>
                                <div className='col-lg-12 pt10 col-12 d-flex justify-content-end align-items-center'>
                                    <button className="ree-btn ree-btn-grdt1 w-100" onClick={handleSubmit} id='noorisys-quote'>
                                        {buttonName ? buttonName : 'Get A Free Quote'}
                                    </button>{' '}
                                </div>
                            </div>
                        </form>
                        {interval && <div >
                            <h5 className='text-center pt5' style={{ fontWeight: '300' }}>OR</h5>
                            <h4 className='text-center pt5' style={{ fontWeight: '300' }}>Get Instant Reply</h4>
                            <h4 className='text-center' style={{ fontWeight: '300' }}>Whatsapp Your Requirement</h4>
                            <div className='d-flex justify-content-center pt20'>
                                <a href='https://wa.me/917796614664' rel='noopener noreferrer' target='_blank' onClick={handleWhatsAppClick}> <button className='ree-btn whatsapp-bg' style={{ background: "#25D366", border: "#25D366" }}><i className='fab fa-whatsapp'></i> WhatsApp Now</button></a>
                            </div>
                        </div>}
                    </div>

                </ModalBody>

            </Modal>
        </div>
    )
}

export default GetAQuote


